<div class="date-time-picker">
  <boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
  </boi-validation-error-generic>
  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" *ngIf="labelName" [boiRequiredFormField]="required ? labelName : undefined">
        <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
        <ng-content></ng-content>
      </div>
      <div class="field-input">
        <kendo-datetimepicker [id]="controlId ? controlId : labelName" [placeholder]="placeholder" [format]="format"
          [min]="min" [max]="max" (blur)="onBlur()" [(ngModel)]="value" [disabled]="isFieldDisabled"
          [popupSettings]="{ animate: false, appendTo: 'component' }">
        </kendo-datetimepicker>
      </div>
    </div>
    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
  </kendo-textbox-container>
</div>